<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 content-card">
        <div class="container"
             :class="containerSizeSmall ? 'container-fixed-768' : 'container-fixed-992'">
          <div class="content-card-header">
            <h1><img v-if="icon != ''" :src="$image(`assets/${icon}`)"/> {{ title }}
            </h1>
            <div>
              <ButtonElement v-if="step != ''" class="btn--ms btn--silent btn--medium btn--xs">{{ step }}</ButtonElement>
            </div>
          </div>
        </div>
        <div class="container "
             :class="containerSizeSmall ? 'container-fixed-768' : 'container-fixed-992'">
          <div class="content-card-body">
            <div class="row">
              <div class="col-12">
                <slot/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import ButtonElement from '@shared/components/elements/button/button.element.vue'

export default defineComponent({
  name: 'ContentTemplate',
  components: {
    ButtonElement
  },
  data () {
    return {}
  },
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    step: {
      type: String,
      default: ''
    },
    containerSizeSmall: {
      type: Boolean,
      default: false
    }
  }
})
</script>
<style lang="scss" scoped>
.content-card {
  .content-card-header {
    padding: var(--space-0) var(--space-0) var(--space-16) var(--space-0);
    display: flex;
    justify-content: space-between;

    h1 {
      margin: var(--space-0);
      margin-bottom: var(--space-16);
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin-right: var(--space-16);
      }
    }
  }
}
</style>
